import React from 'react';
import { Images } from '../../../../utils/imageConstants';
import type { IProfileClaim, IProfileClaimProfile } from '../types/request';

function getProfileName(p: IProfileClaimProfile | undefined): string {
  if (!p) return '-';
  const first = p.playerFirstName ?? p.firstName ?? '';
  const last = p.playerLastName ?? p.lastName ?? '';
  const full = [first, last].filter(Boolean).join(' ');
  return full || p.name || '-';
}

function getProfileImage(p: IProfileClaimProfile | undefined): string {
  if (!p?.imageUri) return Images.player_image;
  const cdnBaseUrl = import.meta.env.VITE_IMAGE_CDN_BASE_URL;
  if (!cdnBaseUrl) return Images.player_image;
  const base = cdnBaseUrl.replace(/\/$/, '');
  const path = p.imageUri.startsWith('/') ? p.imageUri : `/${p.imageUri}`;
  return `${base}${path}`;
}

interface ClaimProfileCardProps {
  claim: IProfileClaim;
  selected: boolean;
  onToggleSelect: () => void;
  onApprove?: () => void;
  onReject?: () => void;
  actionSubmitting?: boolean;
}

export const ClaimProfileCard: React.FC<ClaimProfileCardProps> = ({
  claim,
  selected,
  onToggleSelect,
  onApprove,
  onReject,
  actionSubmitting,
}) => {
  const profile1 =
    claim.unClaimedPlayer ?? claim.profile1 ?? claim.sourceProfile ?? claim.claimingProfile ?? claim.player1;
  const profile2 =
    claim.claimedPlayer ?? claim.profile2 ?? claim.targetProfile ?? claim.claimedProfile ?? claim.player2;
  const name1 = getProfileName(profile1);
  const name2 = getProfileName(profile2);
  const img1 = getProfileImage(profile1);
  const img2 = getProfileImage(profile2);

  return (
    <div className={`claim-profile-card ${selected ? 'selected' : ''}`}>
      <div className="claim-profile-card-checkbox">
        <input
          type="checkbox"
          checked={selected}
          onChange={onToggleSelect}
          aria-label={`Select claim ${name1} / ${name2}`}
        />
      </div>
      <div className="claim-profile-card-profiles">
        <div className="claim-profile-card-profile">
          <div className="claim-profile-card-avatar">
            <img src={img1} alt="" />
          </div>
          <div className="claim-profile-card-info">
            <div className="claim-profile-card-name">{name1}</div>
            <button type="button" className="claim-profile-card-link">
              View Profile
            </button>
          </div>
        </div>
        <div className="claim-profile-card-profile">
          <div className="claim-profile-card-avatar">
            <img src={img2} alt="" />
          </div>
          <div className="claim-profile-card-info">
            <div className="claim-profile-card-name">{name2}</div>
            <button type="button" className="claim-profile-card-link">
              View Profile
            </button>
          </div>
        </div>
      </div>
      {(onApprove || onReject) && (
        <div className="claim-profile-card-actions">
          <button
            type="button"
            className="claim-profile-card-btn-approve"
            onClick={onApprove}
            disabled={actionSubmitting}
          >
            Accept
          </button>
          <button
            type="button"
            className="claim-profile-card-btn-reject"
            onClick={onReject}
            disabled={actionSubmitting}
          >
            Reject
          </button>
        </div>
      )}
    </div>
  );
};
